export default "assets/images/map-location-9bdc4359.jpg";